<customer-header-template [customer]="data.customer"></customer-header-template>

<finder-upload [category]="category" [initial]="initial" searchType="customer" [id]="data.customer.id"></finder-upload>
